<template>
  <v-footer app fixed padless class="font-weight-medium blue lighten-4">
    <v-col class="text-center" cols="12">
      <v-icon fab color="black">copyright</v-icon> {{ year }} —
      <strong>
        <a href="mailto:info@shahrmin.com?subject=ContactUs">
          {{ copyRight }}
        </a>
      </strong>
    </v-col>
  </v-footer>
</template>

<script>
export default {
  name: 'AppNavigation',
  data() {
    return {
      copyRight: 'Shahrmin',
      year: 2020
    }
  }
}
</script>

<style scoped>
a {
  text-decoration: unset;
  color: initial !important;
}
</style>
